export default "__VITE_PUBLIC_ASSET__f65b5bc9__"